module.exports = __webpack_public_path__ + "static/full-lawn-d5f06928daa24f8f5640a291fc25b5fb.jpg";